import type {ComponentProps} from 'react';
import Link from 'next/link';

import {cn} from '@/utils/tailwind';

import type {LinkFragment} from '../../link/query';
import {linkFragmentToHref} from '../../link/query';

export type PortableLinkProps = Omit<
	ComponentProps<typeof Link>,
	'target' | 'href'
> & {
	value?: LinkFragment;
};

export const PortableLink = ({
	children,
	value,
	className,
	...rest
}: PortableLinkProps) => {
	if (!value) {
		return null;
	}
	return (
		<Link
			href={linkFragmentToHref(value)}
			className={cn(
				'visited:text-primary-text-subtle',
				'text-primary-text-subtle',
				'underline',
				'underline-offset-4',
				'hover:no-underline',
				className,
			)}
			{...(value?.targetBlank && {target: '_blank'})}
			{...rest}
		>
			{children}
		</Link>
	);
};
